
import { FileValidationResult } from './types';

export const validateFile = (
  file: File,
  maxSizeInMB: number = 5,
  accept: string = '*/*'
): FileValidationResult => {
  // Check if file exists
  if (!file) {
    return {
      valid: false,
      error: 'No file selected'
    };
  }

  // Check file size
  const fileSize = file.size / (1024 * 1024); // Convert to MB
  if (fileSize > maxSizeInMB) {
    return {
      valid: false,
      error: `File size exceeds ${maxSizeInMB} MB limit`
    };
  }

  // Check file type if accept is provided
  if (accept !== '*/*') {
    const acceptedTypes = accept.split(',').map(type => type.trim());
    const fileType = file.type;
    const fileExtension = `.${file.name.split('.').pop()?.toLowerCase()}`;
    
    const isAccepted = acceptedTypes.some(type => {
      // Handle wildcards like image/* or .jpg
      if (type.includes('*')) {
        const typeCategory = type.split('/')[0];
        return fileType.startsWith(`${typeCategory}/`);
      }
      
      // Handle specific extensions like .jpg, .png
      if (type.startsWith('.')) {
        return fileExtension === type.toLowerCase();
      }
      
      // Handle specific mime types
      return fileType === type;
    });
    
    if (!isAccepted) {
      return {
        valid: false,
        error: `File type not accepted. Please use: ${acceptedTypes.join(', ')}`
      };
    }
  }

  return {
    valid: true
  };
};
